// extracted by mini-css-extract-plugin
export var dropdownButton = "_38-0";
export var fullWidthDropdownButton = "_38-1";
export var icon = "_38-3";
export var iconPlaceholder = "_38-2";
export var menuItemRow = "_38-9";
export var separator = "_38-e";
export var shortcutContainer = "_38-7";
export var shortcutContainerFilled = "_38-8";
export var shortcutIconLg = "_38-6";
export var shortcutIconMd = "_38-5";
export var shortcutIconSm = "_38-4";
export var submenuChevron = "_38-d";
export var submenuDropdown = "_38-a";
export var submenuTriggerRow = "_38-b";
export var submenuTriggerRowOpen = "_38-c";